export default function accordionBlock() {
	const accordions = document.querySelectorAll('[data-js="accordion"]');
	if (!accordions.length) return;

	accordions.forEach((accordion) => {
		if (accordion.dataset.accordionInit === 'true') return;
		accordion.dataset.accordionInit = 'true';

		const list = accordion.querySelector('[data-js="accordion-list"]');
		if (!list) return;

		const items = Array.from(list.querySelectorAll('.accordion-item'));
		if (!items.length) return;

		const setItemState = (item, isOpen) => {
			const trigger = item.querySelector('[data-js="accordion-trigger"]');
			const panel = item.querySelector('.accordion-panel');
			if (!trigger || !panel) return;

			item.classList.toggle('is-open', isOpen);
			trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
			panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
			panel.hidden = !isOpen;
		};

		items.forEach((item) => {
			const trigger = item.querySelector('[data-js="accordion-trigger"]');
			const isOpen = trigger?.getAttribute('aria-expanded') === 'true' || item.classList.contains('is-open');
			setItemState(item, isOpen);
		});

		items.forEach((item) => {
			const trigger = item.querySelector('[data-js="accordion-trigger"]');
			if (!trigger) return;

			trigger.addEventListener('click', () => {
				const isCurrentlyOpen = item.classList.contains('is-open');

				items.forEach((otherItem) => {
					if (otherItem === item) return;
					setItemState(otherItem, false);
				});

				setItemState(item, !isCurrentlyOpen);
			});
		});
	});
}
